import { render, staticRenderFns } from "./activity-log.vue?vue&type=template&id=2e2327df&"
import script from "./activity-log.vue?vue&type=script&lang=js&"
export * from "./activity-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports